import type {
  IAffiliateProgramCommissionPayload,
} from '@modules/affiliate-program-commissions/submodules/edit/types';
import type { IContextMutationResult } from '@modules/core/services/query/types';
import {
  AFFILIATE_PROGRAM_COMMISSIONS_LIST_QUERY_KEY,
  AFFILIATE_PROGRAM_COMMISSIONS_PERMISSIONS,
} from '@modules/affiliate-program-commissions/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import {
  AFFILIATE_PROGRAM_COMMISSIONS_SAVE_MUTATION_KEY,
  AFFILIATE_PROGRAM_COMMISSIONS_SAVE_URL,
} from '../constants';

export default function useAffiliateProgramCommissionsSaveMutation(): IContextMutationResult<
  void,
  Error,
  IAffiliateProgramCommissionPayload
> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IAffiliateProgramCommissionPayload>({
    mutationKey: [AFFILIATE_PROGRAM_COMMISSIONS_SAVE_MUTATION_KEY],
    mutationFn: (condition) => fetchPut<void>(
      AFFILIATE_PROGRAM_COMMISSIONS_SAVE_URL,
      { condition },
      {
        permission: AFFILIATE_PROGRAM_COMMISSIONS_PERMISSIONS.EDIT,
        urlParams: {
          id: condition.id || 0,
        },
        queryParams: { merchant: condition.merchant_id },
      },
    ),
    async onSuccess({ queryClient, variables }) {
      await queryClient.invalidateQueries({ queryKey: [AFFILIATE_PROGRAM_COMMISSIONS_LIST_QUERY_KEY] });

      displayPresetToast(variables.id ? 'edited' : 'created');
    },
  });
}
